(ns common.fields.company-fields
  (:require [schema.core :as s]
            [common.fields.field :refer [create-field-schema]]))

(def schema
  (let [field-schema (partial create-field-schema :company-module/key-people)]
    (merge (field-schema :company/company-owner
                         [:we.d/no :ta.d/yes :sa.d/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/pfc-responsible
                         [:we.d/no :ta/no :sa/no :ex/rw :in/rw]
                         {})
           (field-schema :company/recent-status
                         [:we.d/no :ta/no :sa/no :ex/rw :in/rw]
                         {})
           (field-schema :company/exit-plan
                         [:we.d/no :ta/no :sa/no :ex/rw :in/rw]
                         {})
           (field-schema :role/guest-sell-side
                         [:we.d/no :ta.d/yes :sa.d/yes :ex.d/no :in.d/no]
                         {})
           (field-schema :asset/name
                         [:we.d/mandatory :sa.d/yes :ta.d/yes :ex/rw :in.d/rw]
                         {})
           (field-schema :company/tag-tags
                         [:we.d/no :sa.d/yes :ta.d/yes :ex/rw :in.d/rw]
                         {})
           (field-schema :company/website
                         [:we/yes :ta.d/yes :sa.d/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/phone
                         [:we/yes :ta/yes :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/established-in
                         [:we/yes :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/business-id
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/duns-number
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/overview
                         [:we/no :ta/no :sa/no :ex/rw :in/rw]
                         {})
           (field-schema :asset/description
                         [:we.d/mandatory :ta.d/yes :sa.d/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/customer-identification-number
                         [:we/no :ta/no :sa/no :ex/rw :in/rw]
                         {})
           (field-schema :company/previous-rounds-description
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/cur-company-registered-capital
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/company-business-type
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/parent-company
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/joint-ventures
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/tag-head-count
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/tag-ownership
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/tag-type
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/tag-maturity
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/tag-stage
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/tag-round
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/tag-credit-rating
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/tag-potential-buyers
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/tag-potential-acquisition-targets
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/tag-fit
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/tag-sub-sector
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/tag-industry-type
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/tag-impact-metrics
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/tag-sector
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/tag-business-model
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/tag-category
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/tag-sales-model
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/tag-industry
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/tag-risks
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/tag-size-category
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/tag-team-type
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/tag-strategy
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/tag-group
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/tag-value-chain
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/tag-investor-type
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/tag-rating
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/tag-strategic-fit
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/tag-m-n-a-potential
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/tag-target-markets
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/tag-ipr
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/tag-technology
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/tag-business-vertical-segment
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/tag-business-unit-function
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/tag-product-category
                         [:we/no :ta/yes :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/tag-membership-category
                         [:we/no :ta/no :sa/no :ex/rw :in/rw]
                         {})
           (field-schema :company/scalable-business
                         [:we/no :ta/no :sa/no :ex/rw :in/rw]
                         {})
           (field-schema :company/one-line-description
                         [:we/no :ta/yes :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/datetime-preferred-starting-date
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/projected-ftes-moving-in
                         [:we/no :ta/no :sa/no :ex/rw :in/rw]
                         {})
           (field-schema :company/why-part-of-maria-01
                         [:we/no :ta/no :sa/no :ex/rw :in/rw]
                         {})
           (field-schema :company/tesi-runway
                         [:we/no :ta/no :sa/no :ex/rw :in/rw]
                         {})
           (field-schema :company/cur-tesi-bang-for-buck
                         [:we/no :ta/no :sa/no :ex/rw :in/rw]
                         {})
           (field-schema :company/cur-tesi-net-debt-per-ebitda
                         [:we/no :ta/no :sa/no :ex/rw :in/rw]
                         {})
           (field-schema :company/cur-tesi-bang-for-buck--sym
                         [:we/no :ta/no :sa/no :ex/rw :in/rw]
                         {})
           (field-schema :company/tesi-equity-ratio
                         [:we/no :ta/no :sa/no :ex/rw :in/rw]
                         {})
           (field-schema :company/quick-ratio
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           (field-schema :company/tesi-net-working-capital-percentage
                         [:we/no :ta/no :sa/no :ex/rw :in/rw]
                         {})
           (field-schema :company/tesi-ebitda-percentage
                         [:we/no :ta/no :sa/no :ex/rw :in/rw]
                         {})
           (field-schema :company/company-view-on-runway-in-months
                         [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                         {})
           )))

(def online-presence
  (let [field-schema (partial create-field-schema :company-module/online-presence)]
    (merge
      (field-schema :company/linkedin
                    [:we/yes :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/crunchbase
                    [:we/yes :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/angellist
                    [:we/yes :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/twitter
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/pitchbook
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/facebook
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/news
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/link-to-company-presentation
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/tracxn
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/youtube
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :asset/street-address
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/hometown
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/HQ-zip-code
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :asset/city
                    [:we/yes :ta/yes :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :asset/country
                    [:we/yes :ta/yes :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :asset/state
                    [:we/yes :ta/yes :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/other-locations
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/team
                    [:we.d/no :ta/yes :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/customer-problems
                    [:we/no :ta/yes :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/problem-solution
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/market-challenges
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/need
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/architecture
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/main-actors
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/incentives
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/deterrents
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/concensus
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/possible-attack-vectors
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/applications
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/verdict-sections
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/roadmap
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/next-development
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/partners
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/tokenomics
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/token-intrinsic-value
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/questions
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/strengths
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/risks
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/industry-category
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})

      (field-schema :company/market-opportunities
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})

      (field-schema :company/sales-pipeline
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})

      (field-schema :company/marketing-plan
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})

      (field-schema :company/technical-due-diligence
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})

      (field-schema :company/company-due-diligence
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})

      (field-schema :company/eis-due-diligence
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})

      (field-schema :company/financials-model-analysis
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/customer-problem-solutions
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/sector
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/cluster
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/category
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/sector-broad
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/sector-sub
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/hkstp-office-location
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/proposed-round-participants
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/preferred-funding-structure
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/hkai-lab
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/global-acceleration-academy
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/revenue-range-ltm
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/background
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/target-market
                    [:we/no :ta/yes :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/customer-segments
                    [:we/no :ta/yes :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/product-service
                    [:we/no :ta/yes :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/business-model
                    [:we/no :ta/yes :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/competition
                    [:we/no :ta/yes :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/weaknesses
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/threats
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/tesi-revenue-details
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/tesi-main-expenses
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/tesi-description-of-corona-mitigation
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/short-description-of-progress-during-last-12-months
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/short-description-of-plans-for-next-12-months
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/short-description-of-key-stakeholders
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/proposed-use-of-proceeds
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/opportunities
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/market-growth
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/earnings-logic
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/description-of-ongoing-investor-talks
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/current-financiers
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/cost-structure
                    [:we/no :ta/yes :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/technology
                    [:we/no :ta/yes :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/business-traction
                    [:we/no :ta/yes :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/scaling-plans
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/ipr
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/competitive-advantages
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/indication
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/known-investors
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/lead-investors
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/irl
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/product-development-status
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/product-development-stage
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/lifecycle
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/TOL-A
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/TOL-B
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/sustainable-development-goals
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/cur-total-available-market
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/cur-serviceable-available-market
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/cur-serviceable-obtainable-market
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/cur-capital-raised
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/cur-previous-round-valuation
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/number-of-employees
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/number-of-employees-in-Finland
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/number-of-customers
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/current-owner
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/outstanding-convertibles-options-and-warrants
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/subsidiaries
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/past-incubators
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/past-accelerators
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/received-awards
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/received-grants
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/received-loans
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/cur-proposed-pre-money-valuation
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/cur-proposed-equity-round-size
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/financials
                    [:we/no :ta/yes :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/tesi-financials
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/financials-comment
                    [:we/no :ta/yes :sa/yes :ex/rw :in/rw]
                    {})

      (field-schema :company/cur-revenue-le-for-current-year
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/cur-ebitda-le-for-current-year
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/cur-costs-le-for-current-year
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/cur-gross-profits-le-for-current-year
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/cur-opex-le-for-current-year
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})

      (field-schema :company/revenue-le-for-current-year-comment
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/ebitda-le-for-current-year-comment
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})

      (field-schema :company/cur-revenue-ltm
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/cur-ebitda-ltm
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/revenue-ltm-comment
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/ebitda-ltm-comment
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})

      (field-schema :company/cur-revenue-last-calendar-year
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/cur-ebitda-last-calendar-year
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/cur-tesi-revenue-2017
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/cur-tesi-revenue-2018
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/cur-tesi-revenue-2019
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/cur-tesi-revenue-2020
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/cur-tesi-ebitda-2017
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/cur-tesi-ebitda-2018
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/cur-tesi-ebitda-2019
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/cur-tesi-ebitda-2020
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})

      (field-schema :company/revenue-last-calendar-year-comment
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/ebitda-last-calendar-year-comment
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/cur-mrr
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/cur-cac
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/cur-clv
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/impact-of-costs-cuts [:we/no :ta/no :sa/yes :ex/rw :in/rw] {})
      (field-schema :company/tesi-corona-impact-on-business [:we/no :ta/no :sa/no :ex/rw :in/rw] {})
      (field-schema :company/current-owners [:we/no :ta/no :sa/no :ex/rw :in/rw] {})
      (field-schema :company/cur-tesi-net-debt [:we/no :ta/no :sa/no :ex/rw :in/rw] {})
      (field-schema :company/tesi-identified-corona-mitigation-without-funding [:we/no :ta/no :sa/no :ex/rw :in/rw] {})
      (field-schema :company/cur-short-term-receivables [:we/no :ta/no :sa/yes :ex/rw :in/rw] {})
      (field-schema :company/cur-cash-and-bank-receivables-at-end-of-last-year [:we/no :ta/no :sa/yes :ex/rw :in/rw] {})
      (field-schema :company/cur-interest-bearing-debt-at-end-of-last-year [:we/no :ta/no :sa/yes :ex/rw :in/rw] {})

      (field-schema :company/cur-short-term-debt [:we/no :ta/no :sa/yes :ex/rw :in/rw] {})
      (field-schema :company/cur-short-term-advances [:we/no :ta/no :sa/yes :ex/rw :in/rw] {})
      (field-schema :company/cur-tesi-net-working-capital [:we/no :ta/no :sa/yes :ex/rw :in/rw] {})
      (field-schema :company/cur-necessary-investments-this-year [:we/no :ta/no :sa/yes :ex/rw :in/rw] {})
      (field-schema :company/cur-long-term-advances [:we/no :ta/no :sa/yes :ex/rw :in/rw] {})
      (field-schema :company/cur-fixed-costs-last-year [:we/no :ta/no :sa/yes :ex/rw :in/rw] {})
      (field-schema :company/cur-fixed-costs-current-last-month [:we/no :ta/no :sa/yes :ex/rw :in/rw] {})
      (field-schema :company/cur-equity [:we/no :ta/no :sa/yes :ex/rw :in/rw] {})
      (field-schema :company/cur-current-cash-position-inc-bank-receivables [:we/no :ta/no :sa/yes :ex/rw :in/rw] {})
      (field-schema :company/cur-current-assets [:we/no :ta/no :sa/yes :ex/rw :in/rw] {})
      (field-schema :company/cur-proposed-funding-from-us [:we/no :ta/no :sa/yes :ex/rw :in/rw] {})
      (field-schema :company/cur-proposed-funding-from-non-govt-sources [:we/no :ta/no :sa/yes :ex/rw :in/rw] {})
      (field-schema :company/cur-balance-sheet-size [:we/no :ta/no :sa/yes :ex/rw :in/rw] {})
      (field-schema :company/cur-accounts-receivable [:we/no :ta/no :sa/yes :ex/rw :in/rw] {})
      (field-schema :company/cur-accounts-payable [:we/no :ta/no :sa/yes :ex/rw :in/rw] {})
      (field-schema :company/cur-burn-rate
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/cur-previous-funding-round
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/date-of-previous-funding-round
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/last-known-6m-growth-rate
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/tesi-export-percentage-of-revenue
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/tesi-corona-percentage-impact-on-2020-revenue
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/tesi-corona-percentage-impact-on-2020-ebitda
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/last-known-12m-growth-rate
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/last-known-24m-growth-rate
                    [:we/no :ta/no :sa/no :ex/rw :in/rw]
                    {})
      (field-schema :company/cur-ebitda-last-known
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/cur-ebit-last-known
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/cur-gross-profit-last-known
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/cur-revenue-last-known
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/cur-cash-balance-last-month
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/cur-cash-balance-last-known
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/cur-debt-balance-last-known
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {})
      (field-schema :company/cur-debt-balance-last-month
                    [:we/no :ta/no :sa/yes :ex/rw :in/rw]
                    {}))))
